module.exports = __webpack_public_path__ + "img/zs_12@2x.69774b83.png";